import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import 'react-quill/dist/quill.snow.css';
import ProjectDashboard from './pages/Project/Dashboard';
import Areas from './pages/Project/Areas';
import Stores from './pages/Project/Stores';
import Regions from './pages/Project/Regions';
import Users from './pages/Project/Users';
import LoginPage from './pages/LoginPage';
import Forms from './pages/Project/Forms';
import Activity from './pages/Project/Activity';
import PrivacyConsentPage from './pages/Project/DataPrivacyConsentManager';
import NewProject from './pages/NewProject';
import DashboardPage from './pages/Dashboard';
import Rolespage from './pages/Project/Roles';
import AdminUsersPage from './pages/AdminUsers';
import ProjectUsersPage from './pages/ProjectUsers';
import ProjectPage from './pages/Projects';
import Reports from './pages/Project/Reports';
import Exports from './pages/Project/Exports';
import Validation from './pages/Project/Validation';
import AuditLogs from './pages/Project/AuditLogs';
import { ProjectProvider } from './context/ProjectContext';
import { UserProvider } from './context/UserContext';
import RequireAuth from './components/RequireAuth';
import MainSidebarLayout from './layouts/MainSidebarLayout';
import ProjectSidebarLayout from './layouts/ProjectSidebarLayout';
import TopBar from './layouts/TopBar';
import { ToastContainer } from 'react-toastify';
import ProjectAccessGuard from './components/ProjectAccessGuard';
import { Outlet } from 'react-router-dom';

const App = () => {
  return (
    <>
      <ToastContainer
          position="top-center"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          pauseOnHover
          draggable
        />
      <Router>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route element={<RequireAuth />}>
            <Route
              element={
                <UserProvider>
                  <ProjectProvider>
                    <MainSidebarLayout />
                  </ProjectProvider>
                </UserProvider>
              }
            >
              <Route
                path="/"
                element={
                    <>
                      <TopBar />
                      <Outlet />
                    </>
                }
              >
              <Route index element={<DashboardPage />} />
              <Route path="/admin-users" element={<AdminUsersPage />} />
              <Route path="/project-users" element={<ProjectUsersPage />} />
              <Route path="/new-project" element={<NewProject />} />
              <Route path="/projects" element={<ProjectPage />} />
              </Route>
            </Route>
            <Route
              element={
                <UserProvider>
                  <ProjectProvider>
                    <ProjectSidebarLayout />
                  </ProjectProvider>
                </UserProvider>
              }
            >
              <Route
                path="/projects/:projectId"
                element={
                  <UserProvider>
                    <ProjectAccessGuard>
                      <TopBar />
                      <Outlet />
                    </ProjectAccessGuard>
                  </UserProvider>
                }
              >
                <Route index element={<ProjectDashboard />} />
                <Route path="dashboard" element={<ProjectDashboard />} />
                <Route path="regions">
                  <Route index element={<Regions />} />
                  <Route path=":regionId/areas" element={<Areas />} />
                </Route>
                <Route path="stores" element={<Stores />} />
                <Route path="roles" element={<Rolespage />} />
                <Route path="consent" element={<PrivacyConsentPage />} />
                <Route path="form-builder" element={<Forms />} />
                <Route path="users" element={<Users />} />
                <Route path="activity" element={<Activity />} />
                <Route path="reports" element={<Reports />} />
                <Route path="exports" element={<Exports />} />
                <Route path="validation" element={<Validation />} />
                <Route path="audit-logs" element={<AuditLogs />} />
              </Route>


            </Route>
          </Route>
        </Routes>
      </Router>
    </>
  );
};

export default App;
